const validate = {};
/* eslint-disable */
const merge = (...sources) => Object.assign({}, ...sources);
const checkFile = (array, collection) => {
  if (collection.hasOwnProperty('file') && collection.file.value) {
    const getFile = array.filter(k => k[0] === 'file');
    return getFile && getFile.length > 0 && getFile[0][1] && getFile[0][1].size > 0;
  }
  return true;
};
const getCollection = collection => {
  const collectionOrderObj = {};
  const collectionProdObj = {};
  const collectionMaterialsObj = {};
  const collectionOfficesObj = {};
  collection.filter(e => e.visible).forEach(e => {
    let title;
    if (e.fieldName) {
      title = e.fieldName;
    } else if (e.paramName) {
      title = e.paramName;
    }
    if (e.adscription === 0) {
      collectionOrderObj[title] = { value: e.require, name: e.paramName };
    } else if (e.adscription === 1 || e.adscription === 2) {
      collectionProdObj[title] = { value: e.require, name: e.paramName };
    } else if (e.adscription === 3) {
      collectionMaterialsObj[title] = { value: e.require, name: e.paramName };
    } else if (e.adscription === 4) {
      collectionOfficesObj[title] = { value: e.require, name: e.paramName };
    }
  });
  return {
    collectionOrderObj,
    collectionProdObj,
    collectionMaterialsObj,
    collectionOfficesObj
  };
};

const isEmpty = value => value === undefined || value === '' || value === null;

const checkProd = (prod, collectionProdObj, prodName = '商品') => {
  if (prod.length < 1) {
    return `${prodName}列表`;
  }
  prod = prod.map(p => {
    for (const k in p.customize) {
      p[decodeURIComponent(k)] = p.customize[k];
    }
    p = merge(p);
    delete p.customize;
    return p;
  });
  return checkObj(prod.map(p => Object.entries(p)).flat(), collectionProdObj);
};

const checkObj = (array, collectionObj) => {
  const res = new Map();
  array.forEach(item => {
    if (collectionObj[item[0]]) {
      if (collectionObj[item[0]].value && collectionObj[item[0]].hasValue !== false) {
        collectionObj[item[0]].hasValue = !isEmpty(item[1]);
      }
    }
  });
  return Object.values(collectionObj)
    .filter(e => e.value && !e.hasValue && !res.has(e) && res.set(e, 1))
    .map(e => e.name)
    .toString();
};

validate.check = (order, collection) => {
  const {
    collectionOrderObj, collectionProdObj
  } = getCollection(collection);
  for (const k in order.customize) {
    order[decodeURIComponent(k)] = order.customize[k];
  }
  const obj = merge(order);
  let prod = Object.assign(order.prods ? order.prods : order.orderSaleList);
  delete obj.customize;
  if (obj.prods) {
    delete obj.prods;
  } else {
    delete obj.orderSaleList;
  }
  let str = '';
  let shipList = '';
  let documentList = '';
  const emptyObjStr = checkObj(Object.entries(obj), collectionOrderObj);
  if (emptyObjStr !== '') {
    const titleList = emptyObjStr.split(',');
    for (let i = 0; i < titleList.length; i++) {
      if (titleList[i] === '发货方式' || titleList[i] === '发货方式详情' || titleList[i] === '发货地址' || titleList[i] === '物流费用') {
        shipList += `${titleList[i]},`;
      } else {
        documentList += `${titleList[i]},`;
      }
    }
    if (documentList !== '') {
      str += `单据详情：${documentList.slice(0, documentList.length - 1)}`;
    }
    if (shipList !== '') {
      if (str.length > 0) {
        str += '  ';
      }
      str += `发货详情：${shipList}`;
    }
  }
  const emptyProdStr = checkProd(prod, collectionProdObj);
  if (emptyProdStr !== '') {
    if (str.length > 0) {
      str += '  ';
    }
    str += `商品详情：${emptyProdStr}`;
  }
  if (str.length > 0) {
    str += '不可为空';
  }
  return str;
};

validate.checkForm = function (form, collection, isModify = false, fileLink) {
  const { order: collectionOrderObj, prod: collectionProdObj } = getCollection(collection);
  const orderArray = [];
  const prodArray = [];
  for (const [k, v] of form.entries()) {
    if (k.indexOf('.') > 7) {
      const t = k.split('.')[1];
      if (t.indexOf('customize[') > -1) {
        let title = t.split('customize[')[1];
        title = title.slice(0, title.length - 1);
        prodArray.push([decodeURIComponent(title), v]);
      } else {
        prodArray.push([t, v]);
      }
    } else if (k.indexOf('customize[') > -1) {
      let title = k.split('customize[')[1];
      title = title.slice(0, title.length - 1);
      orderArray.push([decodeURIComponent(title), v]);
    } else {
      orderArray.push([k, v]);
    }
  }
  let str = '';
  if (!checkFile(orderArray, collectionOrderObj)) {
    if (!isModify || (isModify && (!fileLink || fileLink === ''))) {
      str += '单据详情：合同文件';
    }
  }
  delete collectionOrderObj.file;
  const emptyObjStr = checkObj(orderArray, collectionOrderObj);
  if (emptyObjStr !== '') {
    if (str.length > 0) {
      str += `,${emptyObjStr}`;
    } else {
      str += `单据详情：${emptyObjStr}`;
    }
  }
  const emptyProdStr = checkObj(prodArray, collectionProdObj);
  if (emptyProdStr !== '') {
    if (str.length > 0) {
      str += '  ';
    }
    str += `商品详情：${emptyProdStr}`;
  }
  if (str.length > 0) {
    str += '不可为空';
  }
  return str;
};

validate.checkCust = function (cust, collection) {
  const collectionObj = {};
  collection.forEach(e => {
    collectionObj[e.fieldName] = { value: e.require, name: e.paramName };
  });
  let str = '';
  const custEntries = Object.entries(cust);
  const arrayList = [];
  custEntries.forEach(k => {
    if (k[1] instanceof Array) {
      k[1].forEach(e => {
        Object.entries(e).forEach(k => arrayList.push(k));
      });
    }
  });
  const emptyObjStr = checkObj([...arrayList, ...custEntries], collectionObj);
  if (emptyObjStr !== '') {
    str += `字段：${emptyObjStr}`;
  }
  if (str.length > 0) {
    str += '不可为空';
  }
  return str;
};

validate.isEmptyProd = function (prod) {
  return prod.filter(p => p.isProd !== false).length === 0;
};

validate.getParams = (data) => {
  return [
    ...data.orderParams,
    ...data.productParams,
    ...data.materialsParams,
    ...data.officesParams
  ];
};

validate.getCollection = getCollection;
validate.checkProd = checkProd;


export default validate;
